export default [
  {
    code: 'id',
    name: 'id',
    type: 'number',
    label: 'id',
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'transmitterId',
    name: 'transmitterGuid',
    type: 'input',
    isUuid: true,
  },
  {
    code: 'plugId',
    name: 'plugGuid',
    type: 'select',
    isUuid: true,
    dictionary: 'devices',
    itemValue: 'serial',
    itemText: 'serial',
  },
  {
    code: 'sigfoxId',
    name: 'sigfoxId',
    type: 'input',
  },
  {
    code: 'zigbeeId',
    name: 'zigbeeId',
    type: 'input',
  },
  {
    code: 'level',
    name: 'level',
    type: 'number',
    isNumber: true,
    label: 'level',
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'temperature',
    name: 'temperature',
    label: 'temperature',
    type: 'number',
    isNumber: true,
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'angleX',
    name: 'angleX',
    label: 'angleX',
    type: 'number',
    isNumber: true,
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'angleY',
    name: 'angleY',
    label: 'angleY',
    type: 'number',
    isNumber: true,
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'batteryCharge',
    name: 'batteryCharge',
    label: 'battaryCharge',
    type: 'number',
    isNumber: true,
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'wakeupReason',
    name: 'wakeupReason',
    type: 'select',
    dictionary: 'wakeupReason',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'measureType',
    name: 'measureType',
    type: 'select',
    dictionary: 'measureType',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'corrections',
    name: 'corrections',
    type: 'select',
    dictionary: 'corrections',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'sending',
    name: 'sending',
    type: 'select',
    dictionary: 'sending',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'lastValue',
    name: 'lastValue',
    type: 'checkbox',
    label: 'lastValue',
    itemValue: false,
  },
  // { code: 'measureTime', name: 'measureTime', type: 'input' },
]
